import type { ReactNode } from 'react';

import {
  ecoExplanationText,
  manoExpressExplanationText,
  mmfExplanationText,
} from '@/domains/productDiscovery/Listings/components/Filters/components/FilterExplanation/filterExplanationText';

export const getExplanationText = (
  filterConfigAttributeName: string,
  manoExpress?: boolean,
): ReactNode => {
  let filterExplanationText: ReactNode;

  if (filterConfigAttributeName === 'is_eco_responsible') {
    filterExplanationText = ecoExplanationText;
  } else if (filterConfigAttributeName === 'is_mmf') {
    filterExplanationText = manoExpress
      ? manoExpressExplanationText
      : mmfExplanationText;
  }

  return filterExplanationText;
};
